import { Checkbox } from '@deliveryhero/pd-cookbook/components/Checkbox';
import { Typography } from '@deliveryhero/pd-cookbook/components/Typography';
import { Divider, Grid, InputAdornment } from '@mui/material';
import { FormikProps } from 'formik';

import { AllowanceValuesType } from 'components/Allowance/AllowanceDetailForm';
import ButtonList from 'components/ButtonListSelect';
import DatePickerFilter from 'components/DatePicker';
import { TextField } from 'components/TextField';

import { AllowancePaddedPaper as PaddedPaper } from './AllowancePaddedPaper';
import { budgetTypeButtons } from './buttons';

export const SetAllowanceAmount = ({
  values,
  setFieldValue,
  setValues,
  touched,
  errors,
  currency
}: FormikProps<AllowanceValuesType> & {
  currency: string;
}) => {
  return (
    <Grid item>
      <PaddedPaper title={'Set allowance amount *'} disabled={!values.editable}>
        <Grid item xs={12}>
          <ButtonList
            buttons={budgetTypeButtons.map((b) =>
              b.id === values.budget_type ? { ...b, selected: true } : b
            )}
            handleClick={(id) => {
              values.budget_type !== id && setFieldValue('budget_type', id);
            }}
            disabled={!values.editable}
          />
        </Grid>
        <Grid container item spacing={2}>
          <Grid item xs>
            <TextField
              name="budget"
              onChange={(e) => {
                const match = e.target.value.match(/\d*(?:\.\d{0,2})?/);
                const value_str = match ? match[0] : '';
                setValues({
                  ...values,
                  input_budget: value_str,
                  budget: parseFloat(value_str)
                });
              }}
              value={!values.editable ? '0' : values.input_budget || ''}
              InputProps={{
                type: 'number',
                inputProps: { min: 0, 'data-testid': 'budget-input' },
                startAdornment: (
                  <InputAdornment position="start">{currency}</InputAdornment>
                )
              }}
              fullWidth
              error={
                (touched.input_budget && Boolean(errors.input_budget)) ||
                (touched.budget && Boolean(errors.budget))
              }
              helperText={touched.budget ? errors.input_budget : ''}
              disabled={!values.editable}
            />
          </Grid>
          <Grid container item alignItems="center" justifyContent="center" xs>
            <Grid item xs>
              <div>per employee</div>
            </Grid>
          </Grid>
        </Grid>

        {values.budget_type === 'custom' && (
          <>
            <Grid item xs={12}>
              <Typography type="title-md">{'Specify date range *'}</Typography>
            </Grid>
            <Grid container item spacing={2}>
              <Grid item>
                <DatePickerFilter
                  label={'Start date'}
                  value={values.allowance_date_from || ''}
                  onValueChange={({ selected }) => {
                    selected && setFieldValue('allowance_date_from', selected);
                  }}
                  id={'selected'}
                  options={{
                    inputFormat: 'DD/MM/YYYY',
                    mask: '__/__/____',
                    useLocalTime: true,
                    noMaxDateLimit: true,
                    testId: 'start-date',
                    disabled: !values.editable,
                    error:
                      touched.allowance_date_from &&
                      Boolean(errors.allowance_date_from)
                  }}
                />
              </Grid>

              <Grid
                container
                item
                spacing={0}
                alignItems="center"
                justifyContent="center"
                width={28}
              >
                <Grid item xs>
                  <Divider
                    textAlign="center"
                    sx={{
                      maxWidth: 12
                    }}
                  />
                </Grid>
              </Grid>
              <Grid item>
                <DatePickerFilter
                  label={'End date'}
                  value={values.allowance_date_to || ''}
                  onValueChange={({ selected }) => {
                    selected && setFieldValue('allowance_date_to', selected);
                  }}
                  id={'selected'}
                  options={{
                    inputFormat: 'DD/MM/YYYY',
                    mask: '__/__/____',
                    useLocalTime: true,
                    minDate: values.allowance_date_from,
                    noMaxDateLimit: true,
                    testId: 'end-date'
                  }}
                />
              </Grid>
              {/* <Grid
                container
                item
                spacing={0}
                alignItems="center"
                justifyContent="center"
                width={28}
                xs
              >
                <Grid
                  item
                  xs
                  sx={{
                    '>label >div': {
                      marginLeft: 0
                    }
                  }}
                >
                  <Checkbox
                    id="no-end-date-checkbox"
                    label="No end date"
                    checked={!values.allowance_date_to}
                    onChange={(e) => {
                      e.target.checked
                        ? setFieldValue('allowance_date_to', undefined)
                        : setFieldValue(
                            'allowance_date_to',
                            values.allowance_date_from
                          );
                    }}
                    disabled={!values.editable}
                  />
                </Grid>
              </Grid> */}
            </Grid>
          </>
        )}
      </PaddedPaper>
    </Grid>
  );
};
